import moment from 'moment'
import numeral from 'numeral'
import { converge, or, cond, isEmpty, always, T, F } from 'ramda'
import { isNumeric, isNilOrEmpty } from 'ramda-extension'

const limitHour = moment({ hour: 16, minute: 5 })
const minDate = moment() < limitHour ? moment({ hour: 0 }) : moment({ hour: 0 }).add(1, 'day')

export const inventoryList =
  [
    {
      title: 'Identificador',
      datakey: 'identificador',
      width: '10%',
    },
    {
      title: 'Producto',
      datakey: 'concepto',
      width: '24%',
    },
    {
      title: 'Fecha',
      datakey: 'fecha',
      width: '7%',
      format: data => moment(data).format('DD/MM/YYYY')
    },
    {
      title: 'Entrada',
      datakey: 'entrada',
      width: '5%',
    },
    {
      title: 'Salida',
      datakey: 'salida',
      width: '5%',
    },
    {
      title: 'Saldo',
      datakey: 'saldo',
      width: '5%',
    },
    {
      title: 'Importe',
      datakey: 'total',
      format: '$ 0,0.00',
      width: '8%',
    },
    {
      title: 'Divisa',
      datakey: 'divisa',
      width: '5%',
    },
    {
      title: 'Acciones',
      custom: 'actions',
      width: '7%',
    }
  ]

export const unexpectedStockOutflowList =
  [
    {
      title: 'id',
      datakey: 'id',
      width: '2%',
    },
    {
      title: 'Identificador',
      datakey: 'identificador',
      width: '10%',
    },
    {
      title: 'Producto',
      datakey: 'producto',
      width: '20%',
    },
    {
      title: 'Pedimento',
      datakey: 'pedimentoAduana',
      width: '10%',
    },
    {
      title: 'Fecha',
      datakey: 'fecha',
      width: '8%',
      format: data => moment(data).format('DD/MM/YYYY')
    },
    {
      title: 'Estatus',
      datakey: 'status',
      width: '8%',
    },
    {
      title: 'Motivo',
      datakey: 'motivo',
      width: '8%',
    },
    {
      title: 'Acciones',
      datakey: 'acciones',
      custom: 'actions',
      width: '5%',
    }
  ]

export const filter = {
  product: {
    name: 'product',
    label: 'Producto o servicio',
    valueLabel: 'concepto',
    valueProperty: 'idProducto',
    trigger: 'updateDateLimits',
    validation: 'required',
    value: '',
    input: {
      value: '',
      name: 'product',
      label: 'Producto o servicio',
      valueLabel: 'concepto',
      valueProperty: 'idProducto',
    }
  },
  fechaInicio: {
    name: 'fechaInicio',
    label: 'Fecha inicio',
    value: undefined,
    dataMarshaller: val => val ? moment(val).format('YYYY-MM-DD'): undefined,
  },
  fechaFin: {
    name: 'fechaFin',
    label: 'Fecha fin',
    value: undefined,
    dataMarshaller: val => val ? moment(val).format('YYYY-MM-DD'): undefined,
  },
  idProducto: {
    same: 'product',
  }
}

export const inventory = {
  estatus: {
    name: 'estatus',
    label: 'Estatus',
    disabled: true,
    value: '1',
    valueProperty: 'id',
    valueLabel: 'estatus',
  },
  fecha: {
    name: 'fecha  ',
    label: 'Fecha',
    // validation: 'required',
    value: moment().toDate(),
  },
  idProductoServicio: {
    name: 'idProductoServicio',
    label: 'Clave Producto',
    value: '',
    validation: 'required',
    valueProperty: 'id',
    valueLabel: 'tipo',
    placeholder: 'Buscar producto...',
    trigger: 'getProductOrService',
  },
  identificador: {
    name: 'identificador',
    label: 'Identificador',
    maxLength: 11,
    value: '',
    validation: 'required',
    disabled: true,
  },
  inventoryType: {
    value: 'Entrada',
    name: 'inventoryType',
    label: 'Tipo de inventario',
    options: [
      { value: 'Entrada', label: 'Entrada' },
      { value: 'Salida', label: 'Salida' },
    ],
    hideEmpty: true,
  },
  entrada: {
    value: 0,
    name: 'entrada',
    label: 'Entrada',
    trigger: 'updateSubtotal',
  },
  salida: {
    value: 0,
    name: 'salida',
    label: 'Salida',
    trigger: 'updateSubtotal',
  },
  unitario: {
    value: '',
    name: 'unitario',
    label: 'Valor unitario',
    validation: 'required',
    trigger: 'updateSubtotal',
    disabled: true,
  },
  subtotal: {
    value: '',
    name: 'subtotal',
    label: 'Subtotal',
    disabled: true,
  },
  ieps: {
    value: '0',
    name: 'ieps',
    label: 'IEPS',
    trigger: 'updateSubtotal',
  },
  iva: {
    value: '0',
    name: 'iva',
    label: 'IVA',
    trigger: 'updateSubtotal',
  },
  total: {
    value: '',
    name: 'total',
    label: 'Importe',
    disabled: true,
  },
  divisa: {
    value: 'MXN',
    name: 'divisa',
    label: 'Divisa',
    options: [
      { id: 'MXN', label: 'MXN' },
      { id: 'USD', label: 'USD' }
    ],
    valueProperty: 'id',
    valueLabel: 'label',
    validation: 'required',
  },
  ordenPago: {
    value: '',
    name: 'idOrdenPago',
    label: 'Cargar desde Orden de pago'
  },
  ordenIngreso: {
    value: '',
    name: 'idOrdenIngreso',
    label: 'Cargar desde Orden de ingreso'
  },
  saldo: {
    value: '',
    name: 'saldo',
    label: 'Saldo',
  },
  pedimentoAduana: {
    value: '',
    name: 'pedimentoAduana',
    label: 'Pedimento Aduana',
    disabled: true,
  },
}

export const addressData = {
  direccion: {
    value: '',
    transform: 'stringToBool',
    trigger: 'onChangeDireccion',
    name: 'direccion',
    label: 'Dirección',
    disabled: true,
  },
  pais: {
    name: 'pais',
    value: '',
    validation: 'requiredIf:direccion',
    label: 'País',
    disabled: true
  },
  codigoPostal: {
    value: '',
    trigger: 'onChangeCp',
    pattern: 'number',
    name: 'codigoPostal',
    label: 'Código postal',
    disabled: true,
  },
  entidadFederativa: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'entidadFederativa',
    label: 'Entidad Federativa/Estado/Provincia',
    disabled: true,
  },
  municipio: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'municipio',
    label: 'Municipio',
    disabled: true,
  },
  colonia: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'colonia',
    label: 'Colonia',
    disabled: true,
  },
  calle: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'calle',
    label: 'Calle',
    disabled: true,
  },
  exterior: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'exterior',
    label: 'Exterior',
    disabled: true,
  },
  interior: {
    value: '',
    name: 'interior',
    label: 'Interior',
    disabled: true,
  },
}

export const paymentTable = [
  {
    title: 'id',
    datakey: 'id',
  },
  {
    title: 'Fecha Transacción',
    datakey: 'fechaTransaccion',
  },
  {
    title: 'Estatus',
    datakey: 'estatusTexto',
  },
  {
    title: 'Cargo',
    datakey: 'cargo',
  },
  {
    title: 'Clave Rastreo',
    datakey: 'claveRastreo',
  },
  {
    title: 'Referencia de Banco',
    datakey: 'referenciaBanco',
  },
  {
    title: 'Acciones',
    custom: 'acciones',
  }
]

export const installment = {
  divisaMoneda: {
    name: 'divisaMoneda',
    label: 'Moneda pago',
  },
  cargo: {
    label: 'Cargos',
    name: 'cargo',
    validation: 'required|greaterThan:0',
    pattern: 'number',
    value: 0,
    trigger: 'updateClabe',
    format: (value) => numeral(value).format('$ 0,0.00'),
  },
  fechaTransaccion: {
    label: 'Fecha de Transacción',
    name: 'fechaTransaccion',
    validation: `required|gtOrEqDate:${minDate.format('YYYY-MM-DD')}`,
    value: undefined,
  },
  estatus: {
    label: 'Estatus',
    name: 'estatus',
  },
  idOrden: {
    label: 'Orden Pago',
    name: 'idOrden',
  },
  referencia: {
    label: 'Referencia Banco',
    name: 'referencia',
  },
  metodoPago: {
    label: 'Metódo de pago',
    name: 'metodoPago',
  },
  cuentaMXN: {
    label: 'Cuenta MXN',
    name: 'cuentaMXN',
  },
  claveRastreo: {
    label: 'Clave de rastreo',
    name: 'claveRastreo',
  },
  typePaymentProvider: {
    label: 'Tipo de Pago',
    name: 'typePaymentProvider',
  },
  cuentaClabeColaborador: {
    value: '',
    name: 'cuentaClabeColaborador',
    label: 'Cuenta Clabe Colaborador',
  },
}

export const totals = {
  subtotal: {
    name: 'subtotal',
    label: 'Subtotal',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  IVA: {
    name: 'IVA',
    label: 'IVA',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  ieps: {
    name: 'ieps',
    label: 'IEPS',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  montoPagado: {
    name: 'montoPagado',
    label: 'Monto Pagado',
    value: 0,
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  montoPagoTransito: {
    name: 'montoPagoTransito',
    label: 'Monto Pago Tránsito',
    value: 0,
    format: (value) => numeral(Math.round(+value * 100) / 100).format('$ 0,0.00'),
    align: 'right',
  },
  montoPagar: {
    name: 'montoPagar',
    label: 'Monto por Pagar',
    value: 0,
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  estatusFacturaProveedor: {
    name: 'estatusFactura',
    label: 'Estatus Factura Proveedor',
    valueProperty: 'id',
    valueLabel: 'estatus',
    disabled: true,
    value: '3',
  },
  total: {
    name: 'total',
    label: 'Total',
    value: 0,
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
}

export const unexpectedStockOutflowDetail = {
  id:{
    input: {
      value: '',
      name: 'id',
    },
    label: 'Id',
    disabled: true,
  },
  idProducto: {
    input: {
      value: '',
      name: 'idProducto',
    },
    label: 'ID Producto',
    validate: cond([
      [isEmpty, always({ error: 'Este campo es requerido' })],
      [T, F]
    ]),
  },
  estatus: {
    input: {
      value: '1',
      name: 'estatus',
    },
    label: 'Estatus',
    disabled: true,
    validation: 'required',
    valueProperty: 'id',
    valueLabel: 'estatus',
  },
  fecha: {
    input: {
      value: moment().toDate(),
      name: 'fecha',
    },
    label: 'Fecha',
    validate: cond([
      [isEmpty, always({ error: 'Este campo es requerido' })],
      [T, F]
    ]),
    unmarshaller: (value) => moment(value).toDate(),
    marshall: (value) => {
      return moment(value).format('YYYY-MM-DD')
    } ,
  },
  identificador: {
    input: {
      value: '',
      name: 'identificador',
      disabled: true,
    },
    label: 'Identificador',
  },
  pedimentoAduana: {
    input: {
      value: '',
      name: 'pedimentoAduana',
      disabled: true,
    },
    label: 'Pedimento Aduana',
  },
  piezas: {
    input: {
      value: '',
      name: 'piezas',
    },
    label: 'Piezas',
    validation: 'required|greaterThan:0',
    pattern: converge(or, [isNilOrEmpty, isNumeric]),
    validate: cond([
      [isEmpty, always({ error: 'Este campo es requerido' })],
      [T, F]
    ]),
  },
  unitario: {
    input: {
      value: '',
      name: 'unitario',
      disabled: true,
    },
    label: 'Precio Unitario',
    validation: 'required|greaterThan:0',
    format: value => numeral(value).format('$ 0,0.00'),
    align: 'right',
    pattern: converge(or, [isNilOrEmpty, isNumeric]),
  },
  importe: {
    input: {
      value: '',
      name: 'importe',
      disabled: true,
    },
    label: 'Importe',
    format: value => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  motivoSalida: {
    input: {
      name: 'motivoSalida',
      value: '',
      placeholder: 'Seleccione un motivo',
    },
    type: 'select',
    options: [],
    label: 'Motivo de salida',
    validate: cond([
      [isEmpty, always({ error: 'Este campo es requerido' })],
      [T, F]
    ]),
  },
  detalleSalida: {
    input: {
      value: '',
      name: 'detalleSalida',
    },
    label: 'Detalle Salida',
    validate: cond([
      [isEmpty, always({ error: 'Este campo es requerido' })],
      [T, F]
    ]),
  },
  adjuntos: {
    input: {
      value: '',
      name: 'adjuntos',
    },
    label: 'Adjuntos',
  },
  observaciones: {
    input: {
      value: '',
      name: 'observaciones',
      disabled: true,
    },
    label: 'Observaciones',
  }
}